import React, { useState } from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { MessageSquareIcon, UserIcon, PlusIcon, SearchIcon, PhoneIcon, MailIcon, TagIcon, CalendarIcon, CheckCircleIcon, AlertCircleIcon, ClipboardIcon, RefreshCwIcon, FilterIcon, StarIcon, UserPlusIcon, InfoIcon } from 'lucide-react';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';
const TraderCRM: React.FC = () => {
  const [activeTab, setActiveTab] = useState('contacts');
  const traderContacts = [{
    id: 1,
    name: 'Robert Chen',
    company: 'TechTrade Solutions',
    email: 'robert@techtrade.com',
    phone: '(415) 555-1234',
    type: 'Supplier',
    status: 'Active',
    lastContact: '2023-07-19',
    rating: 4
  }, {
    id: 2,
    name: 'Lisa Williams',
    company: 'Mobile Resellers Inc',
    email: 'lisa@mobileresellers.com',
    phone: '(312) 555-6789',
    type: 'Buyer',
    status: 'Active',
    lastContact: '2023-07-18',
    rating: 5
  }, {
    id: 3,
    name: 'Miguel Rodriguez',
    company: 'Global Phone Exchange',
    email: 'miguel@gpexchange.com',
    phone: '(213) 555-4321',
    type: 'Both',
    status: 'Inactive',
    lastContact: '2023-07-10',
    rating: 3
  }, {
    id: 4,
    name: 'Sarah Johnson',
    company: 'Wireless Wholesale Co',
    email: 'sarah@wirelesswholesale.com',
    phone: '(646) 555-8765',
    type: 'Supplier',
    status: 'Active',
    lastContact: '2023-07-15',
    rating: 4
  }];
  const recentActivities = [{
    id: 1,
    type: 'Call',
    contact: 'Robert Chen',
    description: 'Discussed upcoming iPhone 13 inventory',
    date: '2023-07-19',
    outcome: 'Positive'
  }, {
    id: 2,
    type: 'Email',
    contact: 'Lisa Williams',
    description: 'Sent price list for Samsung devices',
    date: '2023-07-18',
    outcome: 'Pending'
  }, {
    id: 3,
    type: 'Meeting',
    contact: 'Sarah Johnson',
    description: 'Quarterly review meeting',
    date: '2023-07-15',
    outcome: 'Positive'
  }];
  const upcomingDeals = [{
    id: 1,
    title: 'iPhone 13 Pro Bulk Purchase',
    contact: 'Lisa Williams',
    company: 'Mobile Resellers Inc',
    value: '$24,500',
    stage: 'Negotiation',
    probability: '75%',
    closeDate: '2023-07-30'
  }, {
    id: 2,
    title: 'Samsung S22 Trade-In Program',
    contact: 'Miguel Rodriguez',
    company: 'Global Phone Exchange',
    value: '$18,750',
    stage: 'Proposal',
    probability: '50%',
    closeDate: '2023-08-15'
  }];
  return <div className="space-y-6" data-id="element-3519">
      <div className="flex items-center justify-between" data-id="element-3520">
        <div data-id="element-3521">
          <h1 className="text-2xl font-bold" data-id="element-3522">Trader CRM</h1>
          <p className="text-sm text-muted-foreground" data-id="element-3523">
            Manage your buyer and supplier relationships and track
            communications
          </p>
        </div>
        <div className="flex space-x-2" data-id="element-3524">
          <Button variant="outline" data-id="element-3525">
            <MessageSquareIcon className="mr-2 h-4 w-4" data-id="element-3526" />
            Log Activity
          </Button>
          <Button data-id="element-3527">
            <UserPlusIcon className="mr-2 h-4 w-4" data-id="element-3528" />
            Add Contact
          </Button>
        </div>
      </div>
      <Tabs defaultValue="contacts" value={activeTab} onValueChange={setActiveTab} data-id="element-3529">
        <TabsList className="mb-6" data-id="element-3530">
          <TabsTrigger value="contacts" data-id="element-3531">Contacts</TabsTrigger>
          <TabsTrigger value="activities" data-id="element-3532">Activities</TabsTrigger>
          <TabsTrigger value="deals" data-id="element-3533">Deals</TabsTrigger>
        </TabsList>
        <TabsContent value="contacts" className="space-y-6" data-id="element-3534">
          <Card data-id="element-3535">
            <CardHeader className="pb-2" data-id="element-3536">
              <div className="flex items-center justify-between" data-id="element-3537">
                <CardTitle data-id="element-3538">Trader Directory</CardTitle>
                <div className="flex space-x-2" data-id="element-3539">
                  <div className="relative" data-id="element-3540">
                    <SearchIcon className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" data-id="element-3541" />
                    <input type="text" placeholder="Search contacts..." className="pl-10 pr-4 py-2 rounded-md border bg-background text-sm w-64" data-id="element-3542" />
                  </div>
                  <Button variant="outline" size="icon" data-id="element-3543">
                    <FilterIcon className="h-4 w-4" data-id="element-3544" />
                  </Button>
                </div>
              </div>
              <CardDescription data-id="element-3545">
                Your network of buyers and suppliers
              </CardDescription>
            </CardHeader>
            <CardContent data-id="element-3546">
              <div className="overflow-x-auto" data-id="element-3547">
                <table className="w-full" data-id="element-3548">
                  <thead data-id="element-3549">
                    <tr className="border-b" data-id="element-3550">
                      <th className="text-left py-3 px-4 font-medium text-muted-foreground" data-id="element-3551">
                        Name
                      </th>
                      <th className="text-left py-3 px-4 font-medium text-muted-foreground" data-id="element-3552">
                        Company
                      </th>
                      <th className="text-left py-3 px-4 font-medium text-muted-foreground" data-id="element-3553">
                        Type
                      </th>
                      <th className="text-left py-3 px-4 font-medium text-muted-foreground" data-id="element-3554">
                        Status
                      </th>
                      <th className="text-left py-3 px-4 font-medium text-muted-foreground" data-id="element-3555">
                        Rating
                      </th>
                      <th className="text-left py-3 px-4 font-medium text-muted-foreground" data-id="element-3556">
                        Last Contact
                      </th>
                      <th className="text-left py-3 px-4 font-medium text-muted-foreground" data-id="element-3557">
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody data-id="element-3558">
                    {traderContacts.map(contact => <tr key={contact.id} className="border-b hover:bg-muted/50" data-id="element-3559">
                        <td className="py-3 px-4" data-id="element-3560">
                          <div className="flex items-center" data-id="element-3561">
                            <div className="h-8 w-8 rounded-full bg-primary/10 text-primary grid place-items-center mr-2" data-id="element-3562">
                              <span className="text-xs font-medium" data-id="element-3563">
                                {contact.name.substring(0, 2)}
                              </span>
                            </div>
                            <div data-id="element-3564">
                              <p className="font-medium" data-id="element-3565">{contact.name}</p>
                              <p className="text-xs text-muted-foreground" data-id="element-3566">
                                {contact.email}
                              </p>
                            </div>
                          </div>
                        </td>
                        <td className="py-3 px-4" data-id="element-3567">{contact.company}</td>
                        <td className="py-3 px-4" data-id="element-3568">
                          <Badge variant={contact.type === 'Supplier' ? 'success' : contact.type === 'Buyer' ? 'warning' : 'default'} data-id="element-3569">
                            {contact.type}
                          </Badge>
                        </td>
                        <td className="py-3 px-4" data-id="element-3570">
                          <Badge variant={contact.status === 'Active' ? 'success' : 'secondary'} data-id="element-3571">
                            {contact.status}
                          </Badge>
                        </td>
                        <td className="py-3 px-4" data-id="element-3572">
                          <div className="flex" data-id="element-3573">
                            {[...Array(5)].map((_, i) => <StarIcon key={i} className={`h-4 w-4 ${i < contact.rating ? 'text-yellow-500 fill-yellow-500' : 'text-muted-foreground'}`} data-id="element-3574" />)}
                          </div>
                        </td>
                        <td className="py-3 px-4 text-sm" data-id="element-3575">
                          {contact.lastContact}
                        </td>
                        <td className="py-3 px-4" data-id="element-3576">
                          <div className="flex space-x-2" data-id="element-3577">
                            <Button variant="ghost" size="icon" data-id="element-3578">
                              <PhoneIcon className="h-4 w-4" data-id="element-3579" />
                            </Button>
                            <Button variant="ghost" size="icon" data-id="element-3580">
                              <MailIcon className="h-4 w-4" data-id="element-3581" />
                            </Button>
                            <Button variant="ghost" size="sm" data-id="element-3582">
                              View
                            </Button>
                          </div>
                        </td>
                      </tr>)}
                  </tbody>
                </table>
              </div>
            </CardContent>
            <CardFooter className="border-t" data-id="element-3583">
              <div className="text-sm text-muted-foreground" data-id="element-3584">
                Showing 4 of 48 contacts
              </div>
              <div className="ml-auto flex space-x-2" data-id="element-3585">
                <Button variant="outline" size="sm" disabled data-id="element-3586">
                  Previous
                </Button>
                <Button variant="outline" size="sm" data-id="element-3587">
                  Next
                </Button>
              </div>
            </CardFooter>
          </Card>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-3588">
            <Card data-id="element-3589">
              <CardHeader data-id="element-3590">
                <CardTitle data-id="element-3591">Contact Breakdown</CardTitle>
                <CardDescription data-id="element-3592">Distribution by type</CardDescription>
              </CardHeader>
              <CardContent data-id="element-3593">
                <div className="space-y-4" data-id="element-3594">
                  <div className="flex items-center justify-between" data-id="element-3595">
                    <div className="flex items-center" data-id="element-3596">
                      <div className="w-3 h-3 rounded-sm bg-green-500 mr-2" data-id="element-3597"></div>
                      <span className="text-sm" data-id="element-3598">Suppliers</span>
                    </div>
                    <span className="font-medium" data-id="element-3599">24</span>
                  </div>
                  <div className="flex items-center justify-between" data-id="element-3600">
                    <div className="flex items-center" data-id="element-3601">
                      <div className="w-3 h-3 rounded-sm bg-yellow-500 mr-2" data-id="element-3602"></div>
                      <span className="text-sm" data-id="element-3603">Buyers</span>
                    </div>
                    <span className="font-medium" data-id="element-3604">18</span>
                  </div>
                  <div className="flex items-center justify-between" data-id="element-3605">
                    <div className="flex items-center" data-id="element-3606">
                      <div className="w-3 h-3 rounded-sm bg-blue-500 mr-2" data-id="element-3607"></div>
                      <span className="text-sm" data-id="element-3608">Both</span>
                    </div>
                    <span className="font-medium" data-id="element-3609">6</span>
                  </div>
                </div>
              </CardContent>
            </Card>
            <Card data-id="element-3610">
              <CardHeader data-id="element-3611">
                <CardTitle data-id="element-3612">Top Suppliers</CardTitle>
                <CardDescription data-id="element-3613">By transaction volume</CardDescription>
              </CardHeader>
              <CardContent data-id="element-3614">
                <div className="space-y-4" data-id="element-3615">
                  <div className="flex items-center justify-between" data-id="element-3616">
                    <div className="flex items-center" data-id="element-3617">
                      <div className="h-8 w-8 rounded-full bg-primary/10 text-primary grid place-items-center mr-2" data-id="element-3618">
                        <span className="text-xs font-medium" data-id="element-3619">RC</span>
                      </div>
                      <div data-id="element-3620">
                        <p className="font-medium" data-id="element-3621">Robert Chen</p>
                        <p className="text-xs text-muted-foreground" data-id="element-3622">
                          TechTrade Solutions
                        </p>
                      </div>
                    </div>
                    <Badge data-id="element-3623">284 Trades</Badge>
                  </div>
                  <div className="flex items-center justify-between" data-id="element-3624">
                    <div className="flex items-center" data-id="element-3625">
                      <div className="h-8 w-8 rounded-full bg-primary/10 text-primary grid place-items-center mr-2" data-id="element-3626">
                        <span className="text-xs font-medium" data-id="element-3627">SJ</span>
                      </div>
                      <div data-id="element-3628">
                        <p className="font-medium" data-id="element-3629">Sarah Johnson</p>
                        <p className="text-xs text-muted-foreground" data-id="element-3630">
                          Wireless Wholesale Co
                        </p>
                      </div>
                    </div>
                    <Badge data-id="element-3631">156 Trades</Badge>
                  </div>
                </div>
              </CardContent>
            </Card>
            <Card data-id="element-3632">
              <CardHeader data-id="element-3633">
                <CardTitle data-id="element-3634">Top Buyers</CardTitle>
                <CardDescription data-id="element-3635">By purchase volume</CardDescription>
              </CardHeader>
              <CardContent data-id="element-3636">
                <div className="space-y-4" data-id="element-3637">
                  <div className="flex items-center justify-between" data-id="element-3638">
                    <div className="flex items-center" data-id="element-3639">
                      <div className="h-8 w-8 rounded-full bg-primary/10 text-primary grid place-items-center mr-2" data-id="element-3640">
                        <span className="text-xs font-medium" data-id="element-3641">LW</span>
                      </div>
                      <div data-id="element-3642">
                        <p className="font-medium" data-id="element-3643">Lisa Williams</p>
                        <p className="text-xs text-muted-foreground" data-id="element-3644">
                          Mobile Resellers Inc
                        </p>
                      </div>
                    </div>
                    <Badge data-id="element-3645">$124,500</Badge>
                  </div>
                  <div className="flex items-center justify-between" data-id="element-3646">
                    <div className="flex items-center" data-id="element-3647">
                      <div className="h-8 w-8 rounded-full bg-primary/10 text-primary grid place-items-center mr-2" data-id="element-3648">
                        <span className="text-xs font-medium" data-id="element-3649">MR</span>
                      </div>
                      <div data-id="element-3650">
                        <p className="font-medium" data-id="element-3651">Miguel Rodriguez</p>
                        <p className="text-xs text-muted-foreground" data-id="element-3652">
                          Global Phone Exchange
                        </p>
                      </div>
                    </div>
                    <Badge data-id="element-3653">$98,750</Badge>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        </TabsContent>
        <TabsContent value="activities" className="space-y-6" data-id="element-3654">
          <Card data-id="element-3655">
            <CardHeader data-id="element-3656">
              <CardTitle data-id="element-3657">Recent Activities</CardTitle>
              <CardDescription data-id="element-3658">
                Your latest interactions with traders
              </CardDescription>
            </CardHeader>
            <CardContent data-id="element-3659">
              <div className="space-y-4" data-id="element-3660">
                {recentActivities.map(activity => <div key={activity.id} className="flex items-start p-3 border rounded-md" data-id="element-3661">
                    <div className="flex-shrink-0 mr-3" data-id="element-3662">
                      {activity.type === 'Call' ? <PhoneIcon className="h-5 w-5 text-blue-500" data-id="element-3663" /> : activity.type === 'Email' ? <MailIcon className="h-5 w-5 text-green-500" data-id="element-3664" /> : <CalendarIcon className="h-5 w-5 text-purple-500" data-id="element-3665" />}
                    </div>
                    <div className="flex-1" data-id="element-3666">
                      <div className="flex items-center" data-id="element-3667">
                        <p className="font-medium" data-id="element-3668">
                          {activity.type} with {activity.contact}
                        </p>
                        <Badge className="ml-2" variant={activity.outcome === 'Positive' ? 'success' : activity.outcome === 'Negative' ? 'destructive' : 'secondary'} data-id="element-3669">
                          {activity.outcome}
                        </Badge>
                      </div>
                      <p className="text-sm text-muted-foreground mt-1" data-id="element-3670">
                        {activity.description}
                      </p>
                      <p className="text-xs text-muted-foreground mt-1" data-id="element-3671">
                        {activity.date}
                      </p>
                    </div>
                  </div>)}
              </div>
            </CardContent>
            <CardFooter className="border-t" data-id="element-3672">
              <Button variant="outline" size="sm" className="ml-auto" data-id="element-3673">
                View All Activities
              </Button>
            </CardFooter>
          </Card>
          <Card data-id="element-3674">
            <CardHeader data-id="element-3675">
              <CardTitle data-id="element-3676">Log New Activity</CardTitle>
              <CardDescription data-id="element-3677">
                Record your interactions with traders
              </CardDescription>
            </CardHeader>
            <CardContent data-id="element-3678">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4" data-id="element-3679">
                <div className="space-y-2" data-id="element-3680">
                  <label htmlFor="activity-type" className="text-sm font-medium" data-id="element-3681">
                    Activity Type
                  </label>
                  <select id="activity-type" className="w-full p-2 rounded-md border bg-background" data-id="element-3682">
                    <option value="" data-id="element-3683">Select Type</option>
                    <option value="call" data-id="element-3684">Call</option>
                    <option value="email" data-id="element-3685">Email</option>
                    <option value="meeting" data-id="element-3686">Meeting</option>
                    <option value="note" data-id="element-3687">Note</option>
                  </select>
                </div>
                <div className="space-y-2" data-id="element-3688">
                  <label htmlFor="contact" className="text-sm font-medium" data-id="element-3689">
                    Contact
                  </label>
                  <select id="contact" className="w-full p-2 rounded-md border bg-background" data-id="element-3690">
                    <option value="" data-id="element-3691">Select Contact</option>
                    {traderContacts.map(contact => <option key={contact.id} value={contact.id} data-id="element-3692">
                        {contact.name} ({contact.company})
                      </option>)}
                  </select>
                </div>
              </div>
              <div className="space-y-2 mb-4" data-id="element-3693">
                <label htmlFor="description" className="text-sm font-medium" data-id="element-3694">
                  Description
                </label>
                <textarea id="description" className="w-full p-2 rounded-md border bg-background min-h-[100px]" placeholder="Enter details about the interaction..." data-id="element-3695"></textarea>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-3696">
                <div className="space-y-2" data-id="element-3697">
                  <label htmlFor="outcome" className="text-sm font-medium" data-id="element-3698">
                    Outcome
                  </label>
                  <select id="outcome" className="w-full p-2 rounded-md border bg-background" data-id="element-3699">
                    <option value="" data-id="element-3700">Select Outcome</option>
                    <option value="positive" data-id="element-3701">Positive</option>
                    <option value="neutral" data-id="element-3702">Neutral</option>
                    <option value="negative" data-id="element-3703">Negative</option>
                    <option value="pending" data-id="element-3704">Pending</option>
                  </select>
                </div>
                <div className="space-y-2" data-id="element-3705">
                  <label htmlFor="follow-up" className="text-sm font-medium" data-id="element-3706">
                    Follow-up Date
                  </label>
                  <input id="follow-up" type="date" className="w-full p-2 rounded-md border bg-background" data-id="element-3707" />
                </div>
              </div>
            </CardContent>
            <CardFooter className="border-t" data-id="element-3708">
              <Button variant="outline" size="sm" data-id="element-3709">
                Cancel
              </Button>
              <Button size="sm" className="ml-2" data-id="element-3710">
                Save Activity
              </Button>
            </CardFooter>
          </Card>
        </TabsContent>
        <TabsContent value="deals" className="space-y-6" data-id="element-3711">
          <Card data-id="element-3712">
            <CardHeader data-id="element-3713">
              <CardTitle data-id="element-3714">Upcoming Deals</CardTitle>
              <CardDescription data-id="element-3715">Manage your sales pipeline</CardDescription>
            </CardHeader>
            <CardContent data-id="element-3716">
              <div className="space-y-4" data-id="element-3717">
                {upcomingDeals.map(deal => <div key={deal.id} className="p-4 border rounded-md" data-id="element-3718">
                    <div className="flex items-start justify-between" data-id="element-3719">
                      <div data-id="element-3720">
                        <div className="flex items-center" data-id="element-3721">
                          <h3 className="font-medium" data-id="element-3722">{deal.title}</h3>
                          <Badge className="ml-2" data-id="element-3723">{deal.stage}</Badge>
                        </div>
                        <p className="text-sm text-muted-foreground mt-1" data-id="element-3724">
                          {deal.contact} • {deal.company}
                        </p>
                      </div>
                      <div className="text-right" data-id="element-3725">
                        <p className="font-bold" data-id="element-3726">{deal.value}</p>
                        <p className="text-sm text-muted-foreground" data-id="element-3727">
                          {deal.probability} probability
                        </p>
                      </div>
                    </div>
                    <div className="mt-3 flex items-center justify-between text-sm" data-id="element-3728">
                      <span className="text-muted-foreground" data-id="element-3729">
                        Close date: {deal.closeDate}
                      </span>
                      <Button variant="outline" size="sm" data-id="element-3730">
                        Update
                      </Button>
                    </div>
                  </div>)}
              </div>
            </CardContent>
            <CardFooter className="border-t" data-id="element-3731">
              <Button variant="outline" size="sm" className="ml-auto" data-id="element-3732">
                View All Deals
              </Button>
            </CardFooter>
          </Card>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-3733">
            <Card data-id="element-3734">
              <CardHeader data-id="element-3735">
                <CardTitle data-id="element-3736">Deal Pipeline</CardTitle>
                <CardDescription data-id="element-3737">Current deals by stage</CardDescription>
              </CardHeader>
              <CardContent data-id="element-3738">
                <div className="space-y-4" data-id="element-3739">
                  <div className="flex items-center justify-between" data-id="element-3740">
                    <div className="flex items-center" data-id="element-3741">
                      <div className="w-3 h-3 rounded-sm bg-blue-500 mr-2" data-id="element-3742"></div>
                      <span className="text-sm" data-id="element-3743">Prospecting</span>
                    </div>
                    <span className="font-medium" data-id="element-3744">$38,500</span>
                  </div>
                  <div className="flex items-center justify-between" data-id="element-3745">
                    <div className="flex items-center" data-id="element-3746">
                      <div className="w-3 h-3 rounded-sm bg-green-500 mr-2" data-id="element-3747"></div>
                      <span className="text-sm" data-id="element-3748">Proposal</span>
                    </div>
                    <span className="font-medium" data-id="element-3749">$72,250</span>
                  </div>
                  <div className="flex items-center justify-between" data-id="element-3750">
                    <div className="flex items-center" data-id="element-3751">
                      <div className="w-3 h-3 rounded-sm bg-yellow-500 mr-2" data-id="element-3752"></div>
                      <span className="text-sm" data-id="element-3753">Negotiation</span>
                    </div>
                    <span className="font-medium" data-id="element-3754">$124,500</span>
                  </div>
                  <div className="flex items-center justify-between" data-id="element-3755">
                    <div className="flex items-center" data-id="element-3756">
                      <div className="w-3 h-3 rounded-sm bg-purple-500 mr-2" data-id="element-3757"></div>
                      <span className="text-sm" data-id="element-3758">Closing</span>
                    </div>
                    <span className="font-medium" data-id="element-3759">$58,750</span>
                  </div>
                </div>
              </CardContent>
            </Card>
            <Card data-id="element-3760">
              <CardHeader data-id="element-3761">
                <CardTitle data-id="element-3762">Deal Forecast</CardTitle>
                <CardDescription data-id="element-3763">30-day projection</CardDescription>
              </CardHeader>
              <CardContent data-id="element-3764">
                <div className="flex flex-col items-center justify-center h-40" data-id="element-3765">
                  <p className="text-3xl font-bold" data-id="element-3766">$152,750</p>
                  <p className="text-sm text-muted-foreground mt-1" data-id="element-3767">
                    Expected to close in next 30 days
                  </p>
                  <div className="flex items-center mt-2 text-green-500" data-id="element-3768">
                    <InfoIcon className="h-4 w-4 mr-1" data-id="element-3769" />
                    <span className="text-sm" data-id="element-3770">+12.4% vs last month</span>
                  </div>
                </div>
              </CardContent>
            </Card>
            <Card data-id="element-3771">
              <CardHeader data-id="element-3772">
                <CardTitle data-id="element-3773">Quick Actions</CardTitle>
                <CardDescription data-id="element-3774">Common deal activities</CardDescription>
              </CardHeader>
              <CardContent data-id="element-3775">
                <div className="space-y-2" data-id="element-3776">
                  <Button variant="outline" className="w-full justify-start" data-id="element-3777">
                    <PlusIcon className="mr-2 h-4 w-4" data-id="element-3778" />
                    Create New Deal
                  </Button>
                  <Button variant="outline" className="w-full justify-start" data-id="element-3779">
                    <ClipboardIcon className="mr-2 h-4 w-4" data-id="element-3780" />
                    Generate Quote
                  </Button>
                  <Button variant="outline" className="w-full justify-start" data-id="element-3781">
                    <RefreshCwIcon className="mr-2 h-4 w-4" data-id="element-3782" />
                    Update Pipeline
                  </Button>
                </div>
              </CardContent>
            </Card>
          </div>
        </TabsContent>
      </Tabs>
    </div>;
};
export default TraderCRM;